import { createApp } from 'vue'
import App from './App.vue'
import VueHtmlToPaper from './plugins/VueHtmlToPaper'
import { plugin as formKitPlugin, defaultConfig } from '@formkit/vue'
import { createMultiStepPlugin } from '@formkit/addons'
import '@formkit/themes/genesis'
import '@formkit/addons/css/multistep'
createApp(App)
  .use(
    formKitPlugin,
    defaultConfig({
      plugins: [createMultiStepPlugin()]
    })
  )
  .use(VueHtmlToPaper)
  .mount('#app')
